import * as React from 'react';
import Select from 'react-select';
import AsyncSelect from 'react-select/lib/Async';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
export interface CheckBox {
    code: any;
    value: string;
    checked: boolean;
}
export interface SelectInterface {
    value: any;
    label: string;
    checked: boolean;
}
export interface HotelsLeftSidePanelProps extends BaseComponentProps {
    title: string;
    selectedItem: (val: string) => any;
    checkbox: CheckBox[];
    selectItems: CheckBox[];
    versi: number;
    selectType?: string;
}
export interface HotelsLeftSidePanelState extends BaseComponentState {
    searchColapse: boolean;
    copalseIcon: any;
    searchClassname: string;
    checkbox: CheckBox[];
    showSearch: boolean;
    selectItems: SelectInterface[];
    clearable: boolean;
    selectValue: string | any;
}

export class HotelsLeftSidePanel extends BaseComponent<HotelsLeftSidePanelProps, HotelsLeftSidePanelState> {
    constructor(props: HotelsLeftSidePanelProps) {
        super(props);
        this.state = {
            searchColapse: true,
            copalseIcon: <i className="ti-minus" />,
            searchClassname: '',
            checkbox: [],
            showSearch: false,
            selectItems: [],
            clearable: true,
            selectValue: '',
        };
    }

    componentDidUpdate(prevProps: HotelsLeftSidePanelProps, prevState: HotelsLeftSidePanelState) {
        if (prevProps.checkbox !== this.props.checkbox || prevProps.selectItems !== this.props.selectItems || prevProps.versi !== this.props.versi) {
            this.setStateHelper(
                st => {
                    st.checkbox = this.props.checkbox;
                    let selData: SelectInterface[] = [];
                    // let max = 25;
                    // let lop = 0;
                    for (let sel of this.props.selectItems) {
                        selData.push({
                            label: sel.value,
                            value: sel.code,
                            checked: false
                        });
                        // lop++;
                        // if (lop === max) {
                        //    break;
                        // }
                    }
                    st.selectItems = selData;
                });

        }
    }

    colapse: () => any = () => {
        this.setStateHelper(
            prv => {
                let vsearchColapse = true;
                let vcopalseIcon = <i className="ti-minus" />;
                let vsearchClassname = ' ';
                if (this.state.searchColapse) {
                    vsearchColapse = false;
                    vcopalseIcon = <i className="ti-plus" />;
                    vsearchClassname = 'hide';
                }
                prv.searchColapse = vsearchColapse;
                prv.copalseIcon = vcopalseIcon;
                prv.searchClassname = vsearchClassname;
            });
    }

    CheckBoxOnChange(x: any) {
        this.props.selectedItem(x.code);
    }
    renderList: () => any = () => {
        let x = [];
        let loop = 0;

        if (typeof this.state.checkbox !== 'undefined') {
            for (let element of this.state.checkbox) {
                loop++;
                let name = 'chk' + loop;
                let uncheck = '';
                let checked = 'hide';
                if (element.checked) {
                    uncheck = 'hide';
                    checked = '';
                }
                x.push(
                    <div key={loop} className="checkbox check-primary">
                        <label style={{ width: '100%', paddingLeft: 0 }}>
                            <input
                                id={name}
                                type="checkbox"
                                checked={element.checked}
                                onChange={(event) => {
                                    event.preventDefault();
                                    this.CheckBoxOnChange(element);
                                }}
                            />
                            <i className={"checked " + checked} />
                            <i className={"uncheck " + uncheck} />
                            <span style={{ marginLeft: 10, textTransform: 'capitalize' }}>
                                {element.value}
                            </span>
                        </label>
                    </div>
                );
            }
        }
        return x;
    }
    updateValue: (value: any) => any = (value: any) => {
        console.log(value.value);
        this.props.selectedItem(value.value);
    }
    renderPanel: (className: string) => any = (className) => {
        return (
            <div className={'panel-body ' + className}>
                {this.renderList()}
                {this.renderSearch()}
            </div>
        );

    }
    renderSearch = () => { 
        if (this.state.selectItems.length > 0) { 
            if (this.props.selectType === 'hotelName') { 
                const filterColors = (inputValue: string) =>
                    this.state.selectItems.filter((i: any) =>
                        i.label.toLowerCase().includes(inputValue.toLowerCase())
                    );
                const loadOptions = (inputValue: string, callback: any) => {
                    setTimeout(() => { callback(filterColors(inputValue)); }, 1000);
                };
                return (
                    <AsyncSelect  
                        className={`syncSelect`}
                        value={this.state.selectValue}
                        onChange={this.updateValue}
                        loadOptions={loadOptions}
                        placeholder='Search Hotel Name'
                    />);
            } else {
                return (
                    <div   >
                        <Select
                            className="react-select"
                            id="state-select"
                            options={this.state.selectItems}
                            name="selected-state"
                            value={this.state.selectValue}
                            onChange={this.updateValue}
                        />
                    </div>
                );
            }
        } else {
            return <span />;
        }
    }
    render() {
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }
        return (
            <div className="panel panel-white" id="panel1">
                <div className="panel-heading border-light">
                    <h4 className="panel-title text-primary">{this.props.title}</h4>
                    <div className="panel-tools" >
                        <a
                            data-original-title="Collapse"
                            data-toggle="tooltip"
                            data-placement="top"
                            className="btn btn-transparent btn-sm"
                            onClick={(event) => {
                                this.colapse();
                            }}
                        >{this.state.copalseIcon}
                        </a>
                    </div>
                </div>
                {this.renderPanel(this.state.searchClassname)}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/hotels/HotelsLeftSidePanel.tsx